import React, { useState, useEffect } from "react";
import {
  MdOutlineKeyboardArrowRight,
  MdSentimentVeryDissatisfied,
} from "react-icons/md";
import car1 from "../../assets/assets/images/home_images/home_grid4.png";
import car2 from "../../assets/assets/images/home_images/home_grid3.png";
import car3 from "../../assets/assets/images/home_images/home_grid1.png";
import BookingCard from "./BookingCard";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { filteredCars } from "./../../redux/Slice/carSlice";
import { Pagination } from "@mui/material";
import { fetchUserBooking } from "../../redux/Slice/bookingSlice";
import { toast } from "react-toastify";

const CompletedOrder = () => {
  const userBooking = useSelector((state) => state?.booking?.userBooking);
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const cancelBookingData = useSelector(
    (state) => state?.booking?.cancelBooking
  );
  const dispatch = useDispatch();
  const location = useLocation();
  let heading = "Upcoming Booking";
  if (location.pathname === "/mybooking/recent-order")
    heading = "Upcoming Booking";
  if (location.pathname === "/mybooking/completed-order")
    heading = "Completed Booking";
  if (location.pathname === "/mybooking/cancelled-order")
    heading = "Cancelled Booking";

  let bookingMsg = "No upcoming bookings";
  if (location.pathname === "/mybooking/recent-order")
    bookingMsg = "No upcoming bookings";
  if (location.pathname === "/mybooking/completed-order")
    bookingMsg = "No Completed Booking Yet.";
  if (location.pathname === "/mybooking/cancelled-order")
    bookingMsg = "No Cancelled Booking Yet.";

  const [pageData, setPagedata] = useState(null);
  const [completed, setCompleted] = useState([]);
  const [canceled, setCanceled] = useState([]);
  const [status, setStatus] = useState(null);
  const [filteredCars, setFilteredCars] = useState([]);
  let itemsPerPage = 6;
  const numberOfPages = Math.ceil(filteredCars.length / itemsPerPage);
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentPageData = filteredCars.slice(startIndex, endIndex);

  const filterData = (data) => {
    const completedData = data?.filter(
      (item) => item?.status.toLowerCase() === "complete"
    );
    const canceledData = data?.filter(
      (item) => item?.status.toLowerCase() === "cancelled"
    );
    setCompleted(completedData);
    setCanceled(canceledData);
  };
  useEffect(() => {
    setPagedata(userBooking?.data);
  }, [userBooking]);

  useEffect(() => {
    // Call the filterData function with the pageData?.data array
    if (pageData?.data) {
      filterData(pageData?.data);
    }
  }, [pageData?.data, location.pathname]);
  useEffect(() => {
    let filteredData = [];
    if (
      location.pathname === "/mybooking/recent-order" ||
      location.pathname === "/mybooking"
    ) {
      filteredData = pageData?.data || [];
    } else if (location.pathname === "/mybooking/completed-order") {
      filteredData = completed;
    } else if (location.pathname === "/mybooking/cancelled-order") {
      filteredData = canceled;
    }
    setFilteredCars(filteredData);
    // setCurrentPage(1); // Reset to the first page whenever the location changes
  }, [location, pageData, completed, canceled]);

  useEffect(() => {
    if (cancelBookingData?.data?.success) {
      toast(cancelBookingData?.data?.message);
    }
  }, [cancelBookingData]);

  return (
    <div className="container-lg container-fluid">
      <h4 className="secondaryColor mb-4">{heading}</h4>
      {currentPageData && currentPageData.length > 0 ? (
        currentPageData?.map((ele, index) => (
          <BookingCard
            data={ele}
            startDate={ele?.pickUpDateandTime}
            endDate={ele?.returnDateandTime}
            price={ele?.amount}
          />
        ))
      ) : (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ minHeight: "200px" }}
        >
          <MdSentimentVeryDissatisfied
            style={{ fontSize: "48px", marginRight: "10px" }}
          />
          <p className="accentColor ">{bookingMsg}</p>
        </div>
      )}
      {/* <hr className='my-0' /> */}
      {currentPageData && currentPageData.length > 0 && (
        <Pagination
          count={numberOfPages}
          page={currentPage}
          onChange={handlePageChange}
          shape="rounded"
        />
      )}
    </div>
  );
};

export default CompletedOrder;
